import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import type { TableCellComponent } from '../table-cell/table-cell.component';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'pct-feature-table-material-date-cell',
  imports: [DatePipe],
  template: `{{ value() | date: 'shortDate' }}`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block w-[115px]',
  },
})
export class DateCellComponent<T> implements TableCellComponent<T, Date | string> {
  readonly rowItem = input.required<T>();
  readonly value = input.required<Date | string>();
  readonly params = input.required();
}
